export const VERIFY_CHANNELS = "verifiedChannels" as const;
export const VERIFY_PERFORMANCE_GOALS = "verifiedPerformanceGoals" as const;
export const VERIFY_CALENDAR_OF_EVENTS = "verifiedCalendarOfEvents" as const;
export const VERIFY_ADDITIONAL_DATA = "verifiedAdditionalData" as const;

export type VerifiedStep = {
  verified: boolean;
  verified_by_user_id: string;
  verified_at: string;
  verified_data: unknown[];
  pending_data: string[];
};
export type MediaPlanDraftStepsTracker = {
  [K in MediaPlanDraftStep]: VerifiedStep;
};

export const MEDIA_PLAN_VERIFY_STEPS = [
  VERIFY_CHANNELS,
  VERIFY_PERFORMANCE_GOALS,
  VERIFY_CALENDAR_OF_EVENTS,
  VERIFY_ADDITIONAL_DATA,
] as const;

export type MediaPlanDraftStep = (typeof MEDIA_PLAN_VERIFY_STEPS)[number];
